import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { T as d, _ as m } from "./directive-daf4e9b6-abc0af54.js";
var o = /*#__PURE__*/function (_m) {
  _inherits(n, _m);
  function n() {
    var _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.slotHasEvent = !1, _this.usingParentElement = !1, _this.totalSlottedElements = 0, _this.handleSlotchange = function (s) {
      if (s.eventPhase !== 2) return;
      var e = s.target,
        l = e == null ? void 0 : e.assignedElements();
      _this.totalSlottedElements = l.length;
      var t = _this.usingParentElement ? e.parentElement : e;
      _this.totalSlottedElements < 1 ? t == null || t.classList.add(n.defaultClassName) : t == null || t.classList.remove(n.defaultClassName);
    };
    return _this;
  }
  /** Create and append a small set of styles when the directive is used. */
  _createClass(n, [{
    key: "createStyleElement",
    value: function createStyleElement(s) {
      var e = document.createElement("style");
      e.innerHTML = ".".concat(n.defaultClassName, " {display: none !important;}"), e.id = n.stylesID, s.appendChild(e);
    }
  }, {
    key: "update",
    value: function update(s, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        _ref2$ = _ref2[0],
        e = _ref2$ === void 0 ? {
          useParent: !1
        } : _ref2$;
      var l = e.useParent,
        t = s.element,
        r = t.getRootNode(),
        i = t.parentElement;
      l && (this.usingParentElement = !0);
      var a = {};
      return l && i ? a.element = i : a.element = t, r.querySelector("#".concat(n.stylesID)) || this.createStyleElement(r), this.slotHasEvent || (t.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(a);
    }
    /**
     * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
     *
     * ```ts
     * html`<div class="slot-wrapper">
     *    <slot ${showIfUsed({useParent: true})}></slot>
     * </div>`
     *
     * html`<slot ${showIfUsed()}></slot>`
     * ```
     */
  }, {
    key: "render",
    value: function render() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          useParent: !1
        },
        s = _ref3.useParent,
        e = _ref3.element;
      e && this.totalSlottedElements < 1 && e.classList.add(n.defaultClassName);
    }
  }]);
  return n;
}(m);
o.defaultClassName = "hide-slot-area";
o.stylesID = "show-if-used-directive-styles";
var h = o;
var c = d(h);
export { c as m };